import React from 'react';
import { Snippet } from 'react-instantsearch/dom';
import ContentCard from '../../shared/LearnContentCard';
import withContentData from './withContentData';

const LessonPathHit = ({ contentData, hit }) => (
  <ContentCard
    {...contentData}
    title={<Snippet attribute="title" hit={hit} />}
    description={<Snippet attribute="description" hit={hit} />}
  />
);

export default withContentData(LessonPathHit);
